import DataObjectField from '@/utilities/classes/data-object-field';
const buildLandlordFileDataObject = (vData, fileName, base64File, fileType) => {
  const dataObject = {
    qdbapi: {
      udata: "EVICTION_DIVERSION_APPLICATION_FILE_UPLOAD",
      field: [
        new DataObjectField(fileType, 6),
        new DataObjectField(vData.LandlordRecordID, 13),
        {
          _fid: "7",
          _filename: fileName,
          __text: base64File,
        },
        
      ],
    },
  };

  return dataObject;
};
export default buildLandlordFileDataObject;
